import { render, staticRenderFns } from "./DividendTable.vue?vue&type=template&id=51dabb4f&scoped=true"
import script from "./DividendTable.vue?vue&type=script&lang=js"
export * from "./DividendTable.vue?vue&type=script&lang=js"
import style0 from "./DividendTable.vue?vue&type=style&index=0&id=51dabb4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dabb4f",
  null
  
)

export default component.exports